import * as React from "react";

function SvgSort(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5v2.5h2.5V5H5zm-1.667-.417c0-.69.56-1.25 1.25-1.25h3.334c.69 0 1.25.56 1.25 1.25v3.334c0 .69-.56 1.25-1.25 1.25H4.583c-.69 0-1.25-.56-1.25-1.25V4.583zM5 12.5V15h2.5v-2.5H5zm-1.667-.417c0-.69.56-1.25 1.25-1.25h3.334c.69 0 1.25.56 1.25 1.25v3.334c0 .69-.56 1.25-1.25 1.25H4.583c-.69 0-1.25-.56-1.25-1.25v-3.334zM11.077 11.91a.833.833 0 011.179 0l1.91 1.912 1.911-1.911a.833.833 0 011.179 1.178l-2.5 2.5a.833.833 0 01-1.179 0l-2.5-2.5a.833.833 0 010-1.178z"
        fill="#2B3235"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.167 4.167c.46 0 .833.373.833.833v10a.833.833 0 01-1.667 0V5c0-.46.373-.833.834-.833z"
        fill="#2B3235"
      />
    </svg>
  );
}

export default SvgSort;
